import React, { Component } from "react";

export default class JSVariables extends Component {

    render() {

        return(<div>Placeholder.</div>);

    }
    
}